import { Injectable } from "@angular/core";
import { JobLogDto } from "app/models";
import { Observable } from "rxjs";
import { ConfigurationService, HttpService } from ".";
import { BaseService } from "./base.service";

@Injectable()
export class LogsService extends BaseService {
    
    constructor(httpService: HttpService,
        configurationService: ConfigurationService) {
            super(httpService, configurationService);
    }

    getLatestJobLogs(): Observable<JobLogDto[]> {
        return this.httpService.get<JobLogDto[]>(this.apiUrl + 'logs/jobs', null);
    }
}